import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import App from "./App";
import "./index.scss";

//全站 axios 都要帶 httpOnly cookie（後端登入會 Set-Cookie: token），
//  搭配後端 cors({ origin, credentials: true }) 才會作用
axios.defaults.withCredentials = true;

//攔截 401（JWT 失效 / 未登入）：丟全域事件，由 main-layout 顯示「登入已逾期」dialog
//  集中在這裡處理的理由：否則每支 service 的每個 catch 都要自己判斷 401。
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.dispatchEvent(new CustomEvent("auth-expired"));
    }
    return Promise.reject(error);
  },
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
